export const APP_SCRIPT_JS = `// ----------------------------------------------------------------
// GOOGLE APPS SCRIPT - VISITOR TRACKER API (V4.3 - Diagnostic)
// ----------------------------------------------------------------

function doGet(e) {
  return handleRequest(e);
}

function doPost(e) {
  return handleRequest(e);
}

function handleRequest(e) {
  var lock = LockService.getScriptLock();
  lock.tryLock(5000); 

  try {
    var params = e.parameter || {};
    
    // Robust POST data parsing
    if (e.postData && e.postData.contents) {
      try {
        var jsonBody = JSON.parse(e.postData.contents);
        for (var key in jsonBody) {
          params[key] = jsonBody[key];
        }
      } catch (err) {
        // failed to parse body, rely on params
      }
    }

    var action = params.action || 'lookup';

    if (action === 'test') {
      return jsonResponse({
        status: "ok", 
        message: "Connection successful", 
        received: params,
        timestamp: new Date().toISOString()
      });
    }

    if (action === 'batch_lookup') {
      var ips = params.ips;
      if (typeof ips === 'string') {
        try { ips = JSON.parse(ips); } catch(e) { ips = [ips]; }
      }
      return handleBatchLookup(ips);
    }
    
    if (action === 'lookup') {
      return handleIpLookup(params.ip);
    }
    
    if (action === 'get_blacklist') {
      return handleGetBlacklist();
    }

    if (action === 'add_blacklist') {
      return handleAddBlacklist(params.pattern, params.category);
    }
    
    return jsonResponse({status: "error", message: "Invalid action: " + action});
    
  } catch (globalErr) {
    return jsonResponse({status: "error", message: "Script Error: " + globalErr.toString()});
  } finally {
    lock.releaseLock();
  }
}

// --- HANDLERS ---

function handleBatchLookup(ips) {
  if (!ips || !Array.isArray(ips) || ips.length === 0) {
    return jsonResponse({results: {}});
  }
  
  var sheet = getSheet('IP_Data'); 
  if (!sheet) sheet = SpreadsheetApp.getActiveSpreadsheet().getSheets()[0];
  
  var lastRow = sheet.getLastRow();
  if (lastRow < 2) return jsonResponse({results: {}});

  // Optimize: Get all data at once if reasonable size
  var startIps = sheet.getRange(2, 1, lastRow - 1, 1).getValues().flat().map(parseIp);
  var results = {};
  
  for (var i = 0; i < ips.length; i++) {
    var ip = ips[i];
    var targetIp = ipToNum(ip);
    
    var low = 0;
    var high = startIps.length - 1;
    var idx = -1;
    
    while (low <= high) {
      var mid = Math.floor((low + high) / 2);
      if (startIps[mid] === targetIp) {
        idx = mid;
        break;
      } else if (startIps[mid] < targetIp) {
        idx = mid; 
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }
    
    if (idx !== -1) {
      // Row is idx + 2 (header + 0-index)
      var rowNum = idx + 2;
      var range = sheet.getRange(rowNum, 2, 1, 4).getValues()[0];
      var endIp = parseIp(range[0]);
      
      if (targetIp <= endIp) {
        results[ip] = {
          found: true,
          country_code: range[1],
          country_name: range[2],
          organization: range[3]
        };
      } else {
        results[ip] = { found: false };
      }
    } else {
      results[ip] = { found: false };
    }
  }
  
  return jsonResponse({results: results});
}

function handleIpLookup(ip) {
  if (!ip) return jsonResponse({error: "No IP"});
  var res = handleBatchLookup([ip]);
  var content = JSON.parse(res.getContent());
  var data = content.results[ip] || { found: false };
  data.ip = ip;
  return jsonResponse(data);
}

function handleGetBlacklist() {
  var sheet = getSheet('Blacklist');
  if (!sheet) return jsonResponse({items: []});
  
  var lastRow = sheet.getLastRow();
  if (lastRow < 2) return jsonResponse({items: []});
  
  var data = sheet.getRange(2, 1, lastRow - 1, 2).getValues();
  var items = [];
  for(var i=0; i<data.length; i++) {
    if(data[i][0]) items.push({pattern: data[i][0], category: data[i][1]});
  }
  return jsonResponse({items: items});
}

function handleAddBlacklist(pattern, category) {
  if (!pattern) return jsonResponse({status: "error", message: "No pattern"});
  var sheet = getOrCreateSheet('Blacklist');
  var lastRow = sheet.getLastRow();
  
  if (lastRow > 1) {
    var checkRows = Math.min(lastRow - 1, 500);
    var startRow = lastRow - checkRows + 1;
    var existing = sheet.getRange(startRow, 1, checkRows, 1).getValues().flat();
    if (existing.indexOf(pattern) !== -1) {
      return jsonResponse({status: "exists", message: "Already exists"});
    }
  }
  sheet.appendRow([pattern, category || 'ISP', new Date()]);
  return jsonResponse({status: "success", message: "Added"});
}

function getSheet(name) {
  return SpreadsheetApp.getActiveSpreadsheet().getSheetByName(name);
}

function getOrCreateSheet(name) {
  var ss = SpreadsheetApp.getActiveSpreadsheet();
  var sheet = ss.getSheetByName(name);
  if (!sheet) {
    sheet = ss.insertSheet(name);
    sheet.appendRow(['Pattern', 'Category', 'Date Added']);
  }
  return sheet;
}

function ipToNum(ip) {
  if (typeof ip !== 'string') return 0;
  var parts = ip.split('.');
  if (parts.length !== 4) return 0;
  return (parseInt(parts[0]) * 16777216) + (parseInt(parts[1]) * 65536) + (parseInt(parts[2]) * 256) + parseInt(parts[3]);
}

function parseIp(val) {
  if (typeof val === 'number') return val;
  return ipToNum(val);
}

function jsonResponse(data) {
  return ContentService.createTextOutput(JSON.stringify(data)).setMimeType(ContentService.MimeType.JSON);
}
`;

export const PHP_CODE = `<?php
/*
Plugin Name: Simple Visitor Tracker (Export Edition)
Description: Tracks visitors, filters bots, identifies traffic sources, allows data export, and sends daily reports.
Version: 4.3.2
Author: Quest Generated
License: GPLv2 or later
*/

if (!defined('ABSPATH')) exit;
define('SVT_VERSION', '4.3.2');

// -------------------------------------------------------------------------
// 1. DATABASE & LOGGING
// -------------------------------------------------------------------------

register_activation_hook(__FILE__, 'svt_activate');
register_deactivation_hook(__FILE__, 'svt_deactivate');
add_action('plugins_loaded', 'svt_update_db_check');

function svt_activate() {
    svt_create_table();
    svt_seed_blacklist();
    if (!wp_next_scheduled('svt_process_sheet_lookup')) {
        wp_schedule_event(time(), 'svt_every_minute', 'svt_process_sheet_lookup');
    }
    if (!wp_next_scheduled('svt_daily_email_report_hook')) {
        wp_schedule_event(strtotime('08:00:00'), 'daily', 'svt_daily_email_report_hook');
    }
    if (!wp_next_scheduled('svt_sync_blacklist_daily')) {
        wp_schedule_event(time(), 'daily', 'svt_sync_blacklist_daily');
    }
}

function svt_deactivate() {
    wp_clear_scheduled_hook('svt_process_sheet_lookup');
    wp_clear_scheduled_hook('svt_daily_email_report_hook');
    wp_clear_scheduled_hook('svt_sync_blacklist_daily');
}

function svt_update_db_check() {
    if (get_option('svt_version') != SVT_VERSION) {
        svt_create_table();
    }
}

function svt_create_table() {
    global $wpdb;
    $table_name = $wpdb->prefix . 'svt_visitor_data';
    $table_blacklist = $wpdb->prefix . 'svt_blacklist';
    $table_logs = $wpdb->prefix . 'svt_logs';
    $charset_collate = $wpdb->get_charset_collate();

    $sql = "CREATE TABLE $table_name (
        id mediumint(9) NOT NULL AUTO_INCREMENT,
        time datetime DEFAULT '0000-00-00 00:00:00' NOT NULL,
        ip_address varchar(45) NOT NULL,
        user_agent varchar(255) NOT NULL,
        page_url varchar(255) NOT NULL,
        referrer varchar(255) NOT NULL,
        traffic_source varchar(100) DEFAULT 'Direct' NOT NULL,
        organization varchar(255) DEFAULT '' NOT NULL,
        country_code varchar(5) DEFAULT '' NOT NULL,
        country_name varchar(100) DEFAULT '' NOT NULL,
        city varchar(100) DEFAULT '' NOT NULL,
        lookup_status varchar(20) DEFAULT 'pending' NOT NULL,
        is_human tinyint(1) DEFAULT 0 NOT NULL,
        PRIMARY KEY  (id)
    ) $charset_collate;";

    $sql_blacklist = "CREATE TABLE $table_blacklist (
        id mediumint(9) NOT NULL AUTO_INCREMENT,
        pattern varchar(255) NOT NULL,
        category varchar(50) DEFAULT 'ISP' NOT NULL,
        created_at datetime DEFAULT CURRENT_TIMESTAMP NOT NULL,
        PRIMARY KEY  (id)
    ) $charset_collate;";

    $sql_logs = "CREATE TABLE $table_logs (
        id mediumint(9) NOT NULL AUTO_INCREMENT,
        event varchar(50) NOT NULL,
        details text NOT NULL,
        time datetime DEFAULT CURRENT_TIMESTAMP NOT NULL,
        PRIMARY KEY  (id)
    ) $charset_collate;";

    require_once(ABSPATH . 'wp-admin/includes/upgrade.php');
    dbDelta($sql);
    dbDelta($sql_blacklist);
    dbDelta($sql_logs);

    update_option('svt_version', SVT_VERSION);
    if (!get_option('svt_email_sender_name')) update_option('svt_email_sender_name', '01ST DIGITAL SOLUTIONS');
    if (!get_option('svt_email_sender_address')) update_option('svt_email_sender_address', 'marketing@01st.info');
}

function svt_seed_blacklist() {
    global $wpdb;
    $table_blacklist = $wpdb->prefix . 'svt_blacklist';
    $count = $wpdb->get_var("SELECT COUNT(*) FROM $table_blacklist");
    
    // Only seed if empty to avoid duplicates on re-activation
    if ($count > 0) return;

    $items = [
        /* DYNAMIC_BLACKLIST_START */
        /* DYNAMIC_BLACKLIST_END */
    ];
    
    if (empty($items)) return;

    foreach ($items as $item) {
        if (isset($item[0]) && !empty($item[0])) {
             $pattern = sanitize_text_field($item[0]);
             $category = isset($item[1]) ? sanitize_text_field($item[1]) : 'ISP';
             $wpdb->insert($table_blacklist, ['pattern' => $pattern, 'category' => $category]);
        }
    }
}

function svt_log($event, $details = '') {
    global $wpdb;
    $table_logs = $wpdb->prefix . 'svt_logs';
    if (is_array($details) || is_object($details)) {
        $details = json_encode($details);
    }
    $wpdb->insert($table_logs, ['event' => substr($event, 0, 50), 'details' => substr($details, 0, 2000)]);
    
    // Cleanup old logs
    if (mt_rand(0, 100) < 5) {
        $wpdb->query("DELETE FROM $table_logs WHERE id < (SELECT id FROM (SELECT id FROM $table_logs ORDER BY id DESC LIMIT 500) as sub ORDER BY id ASC LIMIT 1)");
    }
}

add_filter('cron_schedules', 'svt_add_cron_interval');
function svt_add_cron_interval($schedules) {
    if(!isset($schedules['svt_every_minute'])) {
        $schedules['svt_every_minute'] = array('interval' => 60, 'display' => 'Every Minute');
    }
    return $schedules;
}

// -------------------------------------------------------------------------
// 2. SETTINGS & EXPORT
// -------------------------------------------------------------------------

add_action('admin_init', 'svt_register_settings');
function svt_register_settings() {
    register_setting('svt_options_group', 'svt_apps_script_url');
    register_setting('svt_options_group', 'svt_email_report_enable');
    register_setting('svt_options_group', 'svt_email_recipients');
    register_setting('svt_options_group', 'svt_email_sender_name');
    register_setting('svt_options_group', 'svt_email_sender_address');
}

add_action('admin_post_svt_export_csv', 'svt_export_csv_handler');
function svt_export_csv_handler() {
    if (!current_user_can('manage_options')) wp_die('Unauthorized');
    
    global $wpdb;
    $table_name = $wpdb->prefix . 'svt_visitor_data';
    $scope = isset($_REQUEST['scope']) ? $_REQUEST['scope'] : 'all';
    $where = "WHERE 1=1";
    
    if ($scope === 'companies') {
        $where .= " AND organization NOT LIKE '[ISP]%' AND organization != 'Unknown' AND organization != ''";
    } elseif ($scope === 'humans') {
        $where .= " AND is_human = 1";
    }

    $rows = $wpdb->get_results("SELECT * FROM $table_name $where ORDER BY time DESC", ARRAY_A);
    if (empty($rows)) $rows = [];

    $filename = 'visitor-export-' . $scope . '-' . date('Y-m-d') . '.csv';
    header('Content-Type: text/csv; charset=utf-8');
    header('Content-Disposition: attachment; filename=' . $filename);

    $output = fopen('php://output', 'w');
    fputs($output, "\\xEF\\xBB\\xBF"); 

    fputcsv($output, array('ID', 'Time', 'IP Address', 'Organization', 'Traffic Source', 'Country', 'City', 'Page URL', 'Referrer', 'User Agent', 'Is Human'));

    if (!empty($rows)) {
        foreach ($rows as $row) {
            fputcsv($output, array(
                $row['id'], $row['time'], $row['ip_address'], $row['organization'],
                $row['traffic_source'], $row['country_name'], $row['city'],
                $row['page_url'], $row['referrer'], $row['user_agent'],
                $row['is_human'] ? 'Yes' : 'No'
            ));
        }
    }
    fclose($output);
    exit;
}

// -------------------------------------------------------------------------
// 3. TRACKING
// -------------------------------------------------------------------------

add_action('wp_footer', 'svt_inject_script');
function svt_inject_script() {
    if (current_user_can('manage_options') && !isset($_GET['svt_test'])) {
        echo '<!-- Visitor Tracker: Admin detected, tracking disabled. Add ?svt_test=1 to URL to test. -->';
        return;
    }
    ?>
    <script>
    (function() {
        var ajaxurl = '<?php echo admin_url('admin-ajax.php'); ?>';
        function sendInitialData(geoData) {
            var data = new FormData();
            var searchParams = new URLSearchParams(window.location.search);
            data.append('action', 'svt_track_visit');
            data.append('page_url', window.location.href);
            data.append('referrer', document.referrer);
            data.append('utm_source', searchParams.get('utm_source') || '');
            data.append('utm_medium', searchParams.get('utm_medium') || '');
            data.append('utm_campaign', searchParams.get('utm_campaign') || '');
            if(geoData) {
                data.append('city', geoData.city || '');
                data.append('country_code', geoData.country_code || '');
                data.append('country_name', geoData.country || '');
                var orgName = (geoData.connection && geoData.connection.isp) ? geoData.connection.isp : (geoData.connection ? geoData.connection.org : '');
                data.append('organization', orgName);
            }
            if (navigator.sendBeacon) { navigator.sendBeacon(ajaxurl, data); } else { var xhr = new XMLHttpRequest(); xhr.open('POST', ajaxurl, true); xhr.send(data); }
        }
        var humanVerified = false;
        function verifyHuman() {
            if (humanVerified) return;
            humanVerified = true;
            setTimeout(function() {
                var data = new FormData();
                data.append('action', 'svt_verify_human');
                data.append('page_url', window.location.href);
                if (navigator.sendBeacon) { navigator.sendBeacon(ajaxurl, data); } else { var xhr = new XMLHttpRequest(); xhr.open('POST', ajaxurl, true); xhr.send(data); }
            }, 2000);
        }
        ['mousemove', 'scroll', 'touchstart', 'keydown', 'click'].forEach(function(e) { window.addEventListener(e, verifyHuman, {once: true, passive: true}); });
        
        var sessionKey = 'svt_geo_cache_v2';
        var cached = sessionStorage.getItem(sessionKey);
        if (cached) {
            sendInitialData(JSON.parse(cached));
        } else {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', 'https://ipwho.is/', true);
            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 400) {
                    var resp = JSON.parse(xhr.responseText);
                    if(resp.success) { sessionStorage.setItem(sessionKey, JSON.stringify(resp)); sendInitialData(resp); } else { sendInitialData(null); }
                } else { sendInitialData(null); }
            };
            xhr.onerror = function() { sendInitialData(null); };
            xhr.send();
        }
    })();
    </script>
    <?php
}

add_action('wp_ajax_svt_track_visit', 'svt_record_visit');
add_action('wp_ajax_nopriv_svt_track_visit', 'svt_record_visit');

function svt_record_visit() {
    global $wpdb;
    $ua = strtolower($_SERVER['HTTP_USER_AGENT']);
    $ip = svt_get_ip();
    
    // Log entry attempt
    // svt_log('Visit Attempt', ['ip' => $ip, 'org' => $_POST['organization'] ?? '']);

    if (empty($ua) || strpos($ua, 'bot') !== false || strpos($ua, 'spider') !== false) {
        wp_die();
    }
    
    $table_name = $wpdb->prefix . 'svt_visitor_data';
    $org = isset($_POST['organization']) ? sanitize_text_field($_POST['organization']) : 'Unknown';
    if (svt_is_datacenter_or_isp($org)) $org = '[ISP] ' . $org;
    $referrer = isset($_POST['referrer']) ? sanitize_text_field($_POST['referrer']) : '';
    $utm_source = isset($_POST['utm_source']) ? sanitize_text_field($_POST['utm_source']) : '';
    $utm_medium = isset($_POST['utm_medium']) ? sanitize_text_field($_POST['utm_medium']) : '';
    $source = 'Direct';
    if (!empty($utm_source)) {
        $source = $utm_source . (!empty($utm_medium) ? ' / ' . $utm_medium : '');
    } elseif (!empty($referrer)) {
        $host = parse_url($referrer, PHP_URL_HOST);
        if (preg_match('/(google|bing|yahoo|duckduckgo|baidu|yandex)/i', $host, $m)) { $source = ucfirst($m[1]) . ' Search'; }
        elseif (preg_match('/(facebook|twitter|t\.co|linkedin|instagram|pinterest|reddit|tiktok)/i', $host, $m)) { $source = ($m[1] == 't.co') ? 'Twitter' : ucfirst($m[1]); }
        elseif (strpos($host, 'openai') !== false || strpos($host, 'chatgpt') !== false) { $source = 'ChatGPT'; }
        else { $source = $host; }
    }
    
    $res = $wpdb->insert($table_name, array(
        'time' => current_time('mysql'),
        'ip_address' => substr($ip, 0, 45),
        'user_agent' => substr(sanitize_text_field($_SERVER['HTTP_USER_AGENT']), 0, 255),
        'page_url' => substr(esc_url_raw($_POST['page_url']), 0, 255),
        'referrer' => substr($referrer, 0, 255),
        'traffic_source' => substr($source, 0, 100),
        'organization' => $org,
        'country_code' => isset($_POST['country_code']) ? sanitize_text_field($_POST['country_code']) : '',
        'country_name' => isset($_POST['country_name']) ? sanitize_text_field($_POST['country_name']) : '',
        'city' => isset($_POST['city']) ? sanitize_text_field($_POST['city']) : '',
        'lookup_status' => 'pending',
        'is_human' => 0
    ));
    
    if ($res === false) {
        svt_log('DB Insert Failed', $wpdb->last_error);
    } else {
        svt_log('Visit Recorded', 'ID: ' . $wpdb->insert_id . ' - Org: ' . $org);
    }
    
    wp_die();
}

add_action('wp_ajax_svt_verify_human', 'svt_mark_human');
add_action('wp_ajax_nopriv_svt_verify_human', 'svt_mark_human');

function svt_mark_human() {
    global $wpdb;
    $table_name = $wpdb->prefix . 'svt_visitor_data';
    $ip = svt_get_ip();
    $wpdb->query($wpdb->prepare("UPDATE $table_name SET is_human = 1 WHERE ip_address = %s AND time > %s ORDER BY id DESC LIMIT 1", $ip, date('Y-m-d H:i:s', strtotime('-1 hour'))));
    svt_log('Human Verified', $ip);
    wp_die();
}

// -------------------------------------------------------------------------
// 4. BACKGROUND WORKER & INTELLIGENCE
// -------------------------------------------------------------------------

add_action('svt_process_sheet_lookup', 'svt_process_queue_func');
function svt_process_queue_func() {
    if (get_transient('svt_lookup_process_lock')) return;
    set_transient('svt_lookup_process_lock', true, 30); 

    global $wpdb;
    $table_name = $wpdb->prefix . 'svt_visitor_data';
    $script_url = get_option('svt_apps_script_url');
    
    if (empty($script_url)) {
        update_option('svt_last_lookup_error', 'No App Script URL configured');
        svt_log('Queue Error', 'No App Script URL configured');
        delete_transient('svt_lookup_process_lock');
        return;
    }
    
    // Ensure URL ends in /exec
    if (strpos($script_url, '/exec') === false) {
       $script_url = preg_replace('/\/edit.*$/', '/exec', $script_url);
    }
    
    $limit = 20;
    $pending = $wpdb->get_results("SELECT id, ip_address FROM $table_name WHERE lookup_status = 'pending' ORDER BY id DESC LIMIT $limit");
    
    if ($pending) {
        $ips = [];
        foreach($pending as $p) {
            $ips[] = $p->ip_address;
        }
        
        svt_log('Queue Processing', 'Checking ' . count($ips) . ' IPs against Google Sheet...');
        
        $results = svt_batch_query_google_sheet($ips, $script_url);
        
        if (empty($results)) {
             // Log handled in batch query function
             delete_transient('svt_lookup_process_lock');
             return; 
        }

        // If we got here, connection works. Clear error.
        delete_option('svt_last_lookup_error');
        
        foreach ($pending as $visit) {
            $updateData = ['lookup_status' => 'complete'];
            $ip = $visit->ip_address;
            
            if (isset($results[$ip]) && $results[$ip]['found']) {
                 $data = $results[$ip];
                 if (!empty($data['organization'])) $updateData['organization'] = sanitize_text_field($data['organization']);
                 if (!empty($data['country_code'])) $updateData['country_code'] = sanitize_text_field($data['country_code']);
                 if (!empty($data['country_name'])) $updateData['country_name'] = sanitize_text_field($data['country_name']);
            }
            
            $finalOrg = isset($updateData['organization']) ? $updateData['organization'] : '';
            if (empty($finalOrg)) {
                 $current = $wpdb->get_row("SELECT organization FROM $table_name WHERE id = {$visit->id}");
                 $finalOrg = $current->organization;
            }

            if (!empty($finalOrg) && strpos($finalOrg, '[ISP]') === false) {
                if (svt_matches_generic_keywords($finalOrg)) {
                    svt_add_to_local_blacklist($finalOrg, 'Auto-Detected');
                    svt_push_blacklist_to_sheet($finalOrg, 'Auto-Detected', $script_url);
                    $updateData['organization'] = '[ISP] ' . $finalOrg;
                } 
                elseif (svt_is_datacenter_or_isp($finalOrg)) {
                    $updateData['organization'] = '[ISP] ' . $finalOrg;
                }
            }

            $wpdb->update($table_name, $updateData, array('id' => $visit->id));
        }
        svt_log('Queue Complete', 'Updated ' . count($pending) . ' records.');
    }
    delete_transient('svt_lookup_process_lock');
}

function svt_batch_query_google_sheet($ips, $url) {
    if (empty($ips)) return [];
    $unique_ips = array_unique($ips);
    
    $body_data = ['action' => 'batch_lookup', 'ips' => array_values($unique_ips)];
    
    // 1. TRY POST (Standard)
    $response = wp_remote_post($url, [
        'body' => json_encode($body_data),
        'headers' => [
            'Content-Type' => 'application/json',
            'Expect' => '' 
        ],
        'timeout' => 45,
        'redirection' => 5,
        'httpversion' => '1.1',
        'user-agent' => 'WordPress/SimpleVisitorTracker',
        'blocking' => true,
        'sslverify' => false 
    ]);
    
    $valid_json = false;
    $data = [];

    if (!is_wp_error($response) && wp_remote_retrieve_response_code($response) == 200) {
        $body = wp_remote_retrieve_body($response);
        $data = json_decode($body, true);
        if (json_last_error() === JSON_ERROR_NONE) {
            $valid_json = true;
            svt_log('Google API Success', 'Parsed JSON successfully.');
        } else {
             // DETAILED ERROR ANALYSIS
             $body_strip = substr(strip_tags($body), 0, 300);
             $err_msg = json_last_error_msg();
             
             if (strpos($body, 'Google Accounts') !== false || strpos($body, 'Sign in') !== false) {
                 svt_log('Google API Error', 'PERMISSION DENIED. Returns Login Page.');
                 update_option('svt_last_lookup_error', 'Permission Error: Redeploy Script as "Anyone"');
             } else {
                 svt_log('Google API Error', "JSON Error: $err_msg. Preview: $body_strip");
                 update_option('svt_last_lookup_error', "Invalid JSON: $body_strip");
             }
        }
    } else {
        if(is_wp_error($response)) {
            svt_log('Google API Network Error', $response->get_error_message());
            update_option('svt_last_lookup_error', 'Network Error: ' . $response->get_error_message());
        }
        else {
             svt_log('Google API HTTP Error', 'Code ' . wp_remote_retrieve_response_code($response));
             update_option('svt_last_lookup_error', 'HTTP Error: ' . wp_remote_retrieve_response_code($response));
        }
    }

    // 2. RETRY WITH GET (Fallback) if POST failed
    if (!$valid_json) {
        $get_url = $url . (strpos($url, '?') === false ? '?' : '&') . 'action=batch_lookup&ips=' . urlencode(json_encode(array_values($unique_ips)));
        
        svt_log('Google API Retry', 'Attempting GET fallback...');
        
        $response = wp_remote_get($get_url, [
            'timeout' => 45,
            'httpversion' => '1.1',
            'sslverify' => false
        ]);
        
        if (is_wp_error($response)) {
             // Don't overwrite main error unless necessary
            return [];
        }
        
        $body = wp_remote_retrieve_body($response);
        $data = json_decode($body, true);
        
        if (json_last_error() !== JSON_ERROR_NONE) {
            $body_strip = substr(strip_tags($body), 0, 100);
            svt_log('Google API GET Error', "Invalid JSON. Preview: $body_strip");
            return [];
        } else {
            svt_log('Google API Success', 'Recovered via GET method.');
            $valid_json = true;
        }
    }
    
    if (isset($data['results'])) {
        return $data['results'];
    }
    
    return [];
}

add_action('svt_sync_blacklist_daily', 'svt_sync_blacklist_from_sheet');
function svt_sync_blacklist_from_sheet() {
    $script_url = get_option('svt_apps_script_url');
    if (empty($script_url)) return;
    
    // Ensure URL ends in /exec
    if (strpos($script_url, '/exec') === false) {
       $script_url = preg_replace('/\/edit.*$/', '/exec', $script_url);
    }
    
    svt_log('Blacklist Sync', 'Starting daily sync...');
    
    $api_url = $script_url . (strpos($script_url, '?') === false ? '?' : '&') . 'action=get_blacklist';
    $response = wp_remote_get($api_url, array('timeout' => 20, 'sslverify' => false)); 
    
    if (!is_wp_error($response)) {
        $body = wp_remote_retrieve_body($response);
        $data = json_decode($body, true);
        
        if (isset($data['items']) && is_array($data['items'])) {
            global $wpdb;
            $table_blacklist = $wpdb->prefix . 'svt_blacklist';
            $count = 0;
            foreach ($data['items'] as $item) {
                $pattern = sanitize_text_field($item['pattern']);
                $category = sanitize_text_field($item['category']);
                $exists = $wpdb->get_var($wpdb->prepare("SELECT id FROM $table_blacklist WHERE pattern = %s", $pattern));
                if (!$exists && !empty($pattern)) {
                    $wpdb->insert($table_blacklist, ['pattern' => $pattern, 'category' => $category]);
                    $count++;
                }
            }
            svt_log('Blacklist Sync', "Imported $count new rules.");
        }
    } else {
        svt_log('Blacklist Sync Error', $response->get_error_message());
    }
}

function svt_push_blacklist_to_sheet($pattern, $category, $url) {
    if (empty($url)) return;
    if (strpos($url, '/exec') === false) { $url = preg_replace('/\/edit.*$/', '/exec', $url); }
    
    $body = json_encode(['action' => 'add_blacklist', 'pattern' => $pattern, 'category' => $category]);
    wp_remote_post($url, [
        'body' => $body,
        'headers' => ['Content-Type' => 'application/json', 'Expect' => ''],
        'timeout' => 5,
        'blocking' => false,
        'sslverify' => false
    ]);
}

function svt_add_to_local_blacklist($pattern, $category) {
    global $wpdb;
    $table_blacklist = $wpdb->prefix . 'svt_blacklist';
    $exists = $wpdb->get_var($wpdb->prepare("SELECT id FROM $table_blacklist WHERE pattern = %s", $pattern));
    if (!$exists) {
        $wpdb->insert($table_blacklist, ['pattern' => $pattern, 'category' => $category]);
    }
}

function svt_cleanup_isp_visits() {
    global $wpdb;
    $table_name = $wpdb->prefix . 'svt_visitor_data';
    $rows = $wpdb->get_results("SELECT id, organization FROM $table_name WHERE organization NOT LIKE '[ISP]%'");
    $count = 0;
    foreach($rows as $r) {
        if(svt_is_datacenter_or_isp($r->organization)) {
            $wpdb->update($table_name, ['organization' => '[ISP] ' . $r->organization], ['id' => $r->id]);
            $count++;
        }
    }
    return $count;
}

function svt_predict_category($name) {
    $name = strtolower($name);
    if (preg_match('/(cloud|aws|azure|google|hosting|server|datacenter|vps|dedi|alibaba|digitalocean|linode|hetzner|ovh)/', $name)) {
        return 'Cloud';
    }
    if (preg_match('/(telecom|cable|internet|network|wireless|broadband|mobile|communication|fiber|dsl|dialup|connect|net|wifi|tel)/', $name)) {
        return 'ISP';
    }
    if (preg_match('/(bot|crawler|spider|scrape|search|index|archive)/', $name)) {
        return 'Bot';
    }
    return 'Uncategorized';
}

function svt_matches_generic_keywords($name) {
    $name = strtolower($name);
    $generics = [
        'telecom', 'cable', 'internet', 'network', 'wireless', 'broadband', 'mobile',
        'hosting', 'cloud', 'data', 'server', 'systems', 'services', 'communications',
        'backbone', 'fiber', 'dsl', 'dialup', 'infonet', 'technologies', 'solutions'
    ];
    foreach ($generics as $k) {
        if (strpos($name, $k) !== false) return true;
    }
    return false;
}

function svt_query_google_sheet($ip, $url) {
    $res = svt_batch_query_google_sheet([$ip], $url);
    if (isset($res[$ip])) {
        return ['found' => $res[$ip]['found'], 'org' => $res[$ip]['organization'] ?? '', 'country_code' => $res[$ip]['country_code'] ?? '', 'country_name' => $res[$ip]['country_name'] ?? ''];
    }
    return ['found' => false];
}

// -------------------------------------------------------------------------
// 5. EMAIL REPORTING
// -------------------------------------------------------------------------
add_action('svt_daily_email_report_hook', 'svt_send_daily_report');

function svt_send_daily_report($force = false) {
    if (!$force && get_option('svt_email_report_enable') !== '1') return false;
    $recipients = get_option('svt_email_recipients');
    if (empty($recipients)) return false;
    global $wpdb;
    $table_name = $wpdb->prefix . 'svt_visitor_data';
    $yesterday_start = date('Y-m-d 00:00:00', strtotime('yesterday'));
    $yesterday_end = date('Y-m-d 23:59:59', strtotime('yesterday'));
    $visits = $wpdb->get_results($wpdb->prepare(
        "SELECT * FROM $table_name WHERE time BETWEEN %s AND %s AND organization NOT LIKE '[ISP]%%' AND organization != 'Unknown' AND organization != '' ORDER BY time DESC",
        $yesterday_start, $yesterday_end
    ));
    if (empty($visits)) return false;
    $branding_name = get_option('svt_email_sender_name', '01ST DIGITAL SOLUTIONS');
    $branding_email = get_option('svt_email_sender_address', 'marketing@01st.info');
    $report_date = date('F j, Y', strtotime('yesterday'));
    $subject = "Daily Visitor Report - $report_date - $branding_name";
    ob_start();
    ?>
    <!DOCTYPE html>
    <html>
    <head>
    <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
        .container { max-width: 600px; margin: 20px auto; background: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
        .header { background-color: #1a1a1a; padding: 30px 20px; text-align: center; }
        .header h1 { color: #ffffff; margin: 0; font-size: 24px; letter-spacing: 1px; }
        .content { padding: 30px; }
        .table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        .table th { text-align: left; padding: 12px; border-bottom: 2px solid #eee; color: #888; font-size: 12px; text-transform: uppercase; }
        .table td { padding: 12px; border-bottom: 1px solid #eee; color: #333; font-size: 14px; }
        .company { font-weight: bold; color: #2271b1; font-size: 15px; }
        .source-tag { display: inline-block; background: #f0f0f1; color: #555; padding: 2px 6px; border-radius: 4px; font-size: 11px; margin-top: 4px; }
        .footer { background-color: #f9f9f9; padding: 20px; text-align: center; color: #999; font-size: 12px; border-top: 1px solid #eee; }
        .btn { display: inline-block; background: #2271b1; color: #fff; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin-top: 10px; font-weight: bold; }
    </style>
    </head>
    <body>
    <div class="container">
        <div class="header"><h1><?php echo esc_html($branding_name); ?></h1></div>
        <div class="content">
            <p>Here is your daily summary of companies that visited your website on <strong><?php echo $report_date; ?></strong>.</p>
            <table class="table">
                <thead><tr><th>Company</th><th>Source</th><th>Time</th></tr></thead>
                <tbody>
                <?php foreach ($visits as $v) : ?>
                    <tr>
                        <td><span class="company"><?php echo esc_html($v->organization); ?></span></td>
                        <td><span class="source-tag"><?php echo esc_html($v->traffic_source ? $v->traffic_source : 'Direct'); ?></span></td>
                        <td><?php echo date('H:i', strtotime($v->time)); ?></td>
                    </tr>
                <?php endforeach; ?>
                </tbody>
            </table>
            <div style="text-align:center; margin-top:30px;"><a href="<?php echo admin_url('admin.php?page=simple-visitor-tracker'); ?>" class="btn">View Full Dashboard</a></div>
        </div>
        <div class="footer">&copy; <?php echo date('Y'); ?> <?php echo esc_html($branding_name); ?>.</div>
    </div>
    </body>
    </html>
    <?php
    $message = ob_get_clean();
    $headers = array('Content-Type: text/html; charset=UTF-8');
    $headers[] = 'From: ' . $branding_name . ' <' . $branding_email . '>';

    wp_mail($recipients, $subject, $message, $headers);
    return true;
}

// -------------------------------------------------------------------------
// 6. UTILITIES
// -------------------------------------------------------------------------

function svt_get_ip() {
    $ip = $_SERVER['REMOTE_ADDR'];
    if (!empty($_SERVER['HTTP_CLIENT_IP'])) $ip = $_SERVER['HTTP_CLIENT_IP'];
    elseif (!empty($_SERVER['HTTP_X_FORWARDED_FOR'])) $ip = $_SERVER['HTTP_X_FORWARDED_FOR'];
    if (strpos($ip, ',') !== false) {
        $parts = explode(',', $ip);
        $ip = trim($parts[0]);
    }
    return sanitize_text_field($ip);
}

function svt_get_flag_emoji($code) {
    if (empty($code)) return '';
    if (preg_match('/([A-Z]{2})/', strtoupper($code), $matches)) { $code = $matches[1]; } else { return ''; }
    $base = 127397;
    return mb_chr($base + ord($code[0]), 'UTF-8') . mb_chr($base + ord($code[1]), 'UTF-8');
}

if (!function_exists('mb_chr')) { function mb_chr($ord, $encoding = 'UTF-8') { if ($encoding === 'UCS-4BE') return pack("N", $ord); return mb_convert_encoding(pack("N", $ord), $encoding, 'UCS-4BE'); } }

function svt_is_datacenter_or_isp($name) {
    if (empty($name)) return false;
    $name = strtolower($name);
    global $wpdb;
    $table_blacklist = $wpdb->prefix . 'svt_blacklist';
    static $db_blacklist = null;
    if ($db_blacklist === null) {
        $results = $wpdb->get_results("SELECT pattern FROM $table_blacklist");
        $db_blacklist = array_column($results, 'pattern');
    }
    if (!empty($db_blacklist)) {
        foreach ($db_blacklist as $pattern) {
            if (strpos($name, strtolower($pattern)) !== false) return true;
        }
    }
    return false;
}

// -------------------------------------------------------------------------
// 7. ADMIN INTERFACE
// -------------------------------------------------------------------------

add_action('admin_menu', 'svt_add_admin_menu');
function svt_add_admin_menu() {
    add_menu_page('Visitor Tracker', 'Visitor Tracker', 'manage_options', 'simple-visitor-tracker', 'svt_display_dashboard', 'dashicons-visibility', 6);
    add_submenu_page('simple-visitor-tracker', 'Blacklist', 'Blacklist', 'manage_options', 'svt-blacklist', 'svt_display_blacklist');
    add_submenu_page('simple-visitor-tracker', 'Debug Logs', 'Debug Logs', 'manage_options', 'svt-logs', 'svt_display_logs');
    add_submenu_page('simple-visitor-tracker', 'Settings', 'Settings', 'manage_options', 'svt-settings', 'svt_display_settings');
}

function svt_display_logs() {
    global $wpdb;
    $table_logs = $wpdb->prefix . 'svt_logs';
    
    if (isset($_POST['svt_clear_logs']) && check_admin_referer('svt_clear_logs_nonce')) {
        $wpdb->query("TRUNCATE TABLE $table_logs");
        echo '<div class="notice notice-success is-dismissible"><p>Logs cleared.</p></div>';
    }
    
    $logs = $wpdb->get_results("SELECT * FROM $table_logs ORDER BY id DESC LIMIT 200");
    ?>
    <div class="wrap">
        <h1>Debug Logs</h1>
        <p>Use these logs to diagnose connection issues with Google Apps Script or tracking failures.</p>
        
        <form method="post">
            <?php wp_nonce_field('svt_clear_logs_nonce'); ?>
            <input type="hidden" name="svt_clear_logs" value="1">
            <?php submit_button('Clear all logs', 'secondary', 'submit', false); ?>
        </form>
        
        <div style="background:#fff; border:1px solid #ccc;">
            <table class="wp-list-table widefat fixed striped">
                <thead><tr><th style="width:140px;">Time</th><th style="width:150px;">Event</th><th>Details</th></tr></thead>
                <tbody>
                    <?php if ($logs) : foreach ($logs as $log) : ?>
                    <tr>
                        <td><?php echo $log->time; ?></td>
                        <td><strong><?php echo esc_html($log->event); ?></strong></td>
                        <td style="font-family:monospace; font-size:11px; word-break:break-all;">
                            <?php echo esc_html($log->details); ?>
                        </td>
                    </tr>
                    <?php endforeach; else: ?>
                    <tr><td colspan="3">No logs found.</td></tr>
                    <?php endif; ?>
                </tbody>
            </table>
        </div>
    </div>
    <?php
}

function svt_display_blacklist() {
    global $wpdb;
    $table_blacklist = $wpdb->prefix . 'svt_blacklist';
    $script_url = get_option('svt_apps_script_url');

    // Handle Manual Add
    if (isset($_POST['svt_add_blacklist']) && check_admin_referer('svt_add_blacklist_nonce')) {
        $pattern = sanitize_text_field($_POST['pattern']);
        $category = sanitize_text_field($_POST['category']);
        if (!empty($pattern)) {
            svt_add_to_local_blacklist($pattern, $category);
            svt_push_blacklist_to_sheet($pattern, $category, $script_url);
            echo '<div class="notice notice-success is-dismissible"><p>Rule added and synced to Cloud.</p></div>';
        }
    }

    // Handle Bulk Add
    if (isset($_POST['svt_bulk_blacklist']) && check_admin_referer('svt_bulk_blacklist_nonce')) {
        $lines = explode("\\n", $_POST['bulk_pattern']);
        $categoryInput = sanitize_text_field($_POST['category']);
        $count = 0;
        foreach ($lines as $line) {
            $pattern = sanitize_text_field(trim($line));
            if (!empty($pattern)) {
                $category = $categoryInput;
                if ($categoryInput === 'auto') {
                    $category = svt_predict_category($pattern);
                }
                svt_add_to_local_blacklist($pattern, $category);
                svt_push_blacklist_to_sheet($pattern, $category, $script_url);
                $count++;
            }
        }
        $msg = $count . ' rules added and syncing to Cloud.';
        if (isset($_POST['run_cleanup']) && $_POST['run_cleanup'] == '1') {
            $cleaned = svt_cleanup_isp_visits();
            $msg .= ' Cleanup ran: ' . $cleaned . ' visits updated.';
        }
        echo '<div class="notice notice-success is-dismissible"><p>' . $msg . '</p></div>';
    }

    // Handle Manual Sync
    if (isset($_POST['svt_force_sync']) && check_admin_referer('svt_force_sync_nonce')) {
        svt_sync_blacklist_from_sheet();
         echo '<div class="notice notice-success is-dismissible"><p>Blacklist synced from Google Sheet.</p></div>';
    }

    if (isset($_GET['delete']) && isset($_GET['_wpnonce']) && wp_verify_nonce($_GET['_wpnonce'], 'delete_rule_' . $_GET['delete'])) {
        $id = intval($_GET['delete']);
        $wpdb->delete($table_blacklist, ['id' => $id]);
        echo '<div class="notice notice-success is-dismissible"><p>Rule deleted locally.</p></div>';
    }

    $rules = $wpdb->get_results("SELECT * FROM $table_blacklist ORDER BY created_at DESC");
    ?>
    <div class="wrap">
        <h1>Blacklist Management</h1>
        <p>Define keywords to identify ISPs, Bots, or Cloud Providers.</p>
        
        <div style="background:#fff; padding:20px; border:1px solid #ccd0d4; margin-bottom:20px;">
            <div style="display:flex; gap:30px; flex-wrap:wrap;">
                
                <!-- Single Add -->
                <div style="flex:1; min-width:300px;">
                    <h3>Add Single Rule</h3>
                    <form method="post">
                        <?php wp_nonce_field('svt_add_blacklist_nonce'); ?>
                        <table class="form-table">
                            <tr>
                                <th><label>Keyword</label></th>
                                <td><input type="text" name="pattern" placeholder="e.g. Amazon Data Services" class="regular-text" required></td>
                            </tr>
                            <tr>
                                <th><label>Category</label></th>
                                <td>
                                    <select name="category">
                                        <option value="ISP">ISP</option>
                                        <option value="Cloud">Cloud / Data Center</option>
                                        <option value="Bot">Bot</option>
                                    </select>
                                </td>
                            </tr>
                        </table>
                        <input type="hidden" name="svt_add_blacklist" value="1">
                        <?php submit_button('Add Rule', 'primary', 'submit', false); ?>
                    </form>
                </div>

                <!-- Bulk Add -->
                <div style="flex:1; min-width:300px; border-left:1px solid #eee; padding-left:30px;">
                    <h3>Bulk Import</h3>
                    <form method="post">
                        <?php wp_nonce_field('svt_bulk_blacklist_nonce'); ?>
                        <p style="margin-bottom:5px;">Paste list (one per line):</p>
                        <textarea name="bulk_pattern" rows="5" style="width:100%; font-family:monospace;" placeholder="AGT NET&#10;B Net Solutions&#10;Beijing Baidu Netcom"></textarea>
                        <div style="margin-top:10px;">
                            <label>Category: 
                                <select name="category">
                                    <option value="auto">✨ Auto-Detect (Recommended)</option>
                                    <option value="ISP">ISP</option>
                                    <option value="Cloud">Cloud / Data Center</option>
                                    <option value="Bot">Bot</option>
                                    <option value="Uncategorized">Uncategorized</option>
                                </select>
                            </label>
                            <p class="description">Auto-detect will try to guess if it's an ISP, Cloud, or Bot based on keywords. If unsure, it sets 'Uncategorized'.</p>
                        </div>
                        <div style="margin-top:10px;">
                            <label><input type="checkbox" name="run_cleanup" value="1" checked> Also cleanup existing visits</label>
                        </div>
                        <input type="hidden" name="svt_bulk_blacklist" value="1">
                        <p class="submit"><input type="submit" name="submit" id="submit" class="button button-primary" value="Import Bulk List"></p>
                    </form>
                </div>
            </div>

            <hr>
            <form method="post">
                 <?php wp_nonce_field('svt_force_sync_nonce'); ?>
                 <input type="hidden" name="svt_force_sync" value="1">
                 <p>Pull the latest blacklist from your Google Sheet.</p>
                 <?php submit_button('Force Sync Now', 'secondary', 'submit', false); ?>
            </form>
        </div>

        <table class="wp-list-table widefat fixed striped" style="max-width:800px;">
            <thead><tr><th>Pattern</th><th>Category</th><th>Date</th><th>Action</th></tr></thead>
            <tbody>
                <?php if ($rules) : foreach ($rules as $rule) : ?>
                    <tr>
                        <td><strong><?php echo esc_html($rule->pattern); ?></strong></td>
                        <td><?php echo esc_html($rule->category); ?></td>
                        <td><?php echo date('Y-m-d', strtotime($rule->created_at)); ?></td>
                        <td><a href="<?php echo wp_nonce_url(admin_url('admin.php?page=svt-blacklist&delete=' . $rule->id), 'delete_rule_' . $rule->id); ?>" style="color:#a00;">Delete</a></td>
                    </tr>
                <?php endforeach; else: ?>
                    <tr><td colspan="4">No rules found.</td></tr>
                <?php endif; ?>
            </tbody>
        </table>
    </div>
    <?php
}

function svt_display_dashboard() {
    global $wpdb;
    $table_name = $wpdb->prefix . 'svt_visitor_data';

    if (isset($_POST['svt_run_queue'])) { svt_process_queue_func(); echo '<div class="notice notice-success is-dismissible"><p>Processed 20 IP Lookups.</p></div>'; }
    if (isset($_POST['svt_clear_data'])) { $wpdb->query("TRUNCATE TABLE $table_name"); echo '<div class="notice notice-success is-dismissible"><p>Data cleared.</p></div>'; }
    
    // Strict Filter
    if (isset($_POST['svt_apply_filters'])) {
        $count = svt_cleanup_isp_visits();
        echo '<div class="notice notice-success is-dismissible"><p>Strict Filters Applied. <strong>' . $count . '</strong> visits updated based on current blacklist.</p></div>';
    }

    $hide_isp = isset($_GET['hide_isp']) && $_GET['hide_isp'] == '1';
    $show_humans = isset($_GET['show_humans']) && $_GET['show_humans'] == '1';
    
    $f_org = isset($_GET['f_org']) ? sanitize_text_field($_GET['f_org']) : '';
    $paged = isset($_GET['paged']) ? max(1, intval($_GET['paged'])) : 1;
    $limit = 50;
    $offset = ($paged - 1) * $limit;

    $where = "WHERE 1=1";
    if ($hide_isp) $where .= " AND organization NOT LIKE '[ISP]%' AND organization != 'Unknown' AND organization != ''";
    if ($show_humans) $where .= " AND is_human = 1";
    if ($f_org) $where .= $wpdb->prepare(" AND organization LIKE %s", '%' . $wpdb->esc_like($f_org) . '%');

    $total_query_items = $wpdb->get_var("SELECT COUNT(*) FROM $table_name $where");
    $total_pages = ceil($total_query_items / $limit);
    $visits = $wpdb->get_results("SELECT * FROM $table_name $where ORDER BY time DESC LIMIT $limit OFFSET $offset");
    
    $total_visits = $wpdb->get_var("SELECT COUNT(*) FROM $table_name");
    $companies = $wpdb->get_var("SELECT COUNT(*) FROM $table_name WHERE organization NOT LIKE '[ISP]%' AND organization NOT IN ('Unknown', '')");
    $humans_count = $wpdb->get_var("SELECT COUNT(*) FROM $table_name WHERE is_human = 1");
    // New: Count pending
    $pending_count = $wpdb->get_var("SELECT COUNT(*) FROM $table_name WHERE lookup_status = 'pending'");
    
    $last_error = get_option('svt_last_lookup_error');

    $pagination_args = array('base' => add_query_arg(['paged' => '%#%']), 'format' => '', 'total' => $total_pages, 'current' => $paged);
    ?>
    <div class="wrap">
        <h1 class="wp-heading-inline">Visitor Tracker <span style="font-size:12px; color:#666;">v<?php echo SVT_VERSION; ?></span></h1>
        
        <?php if(current_user_can('manage_options')): ?>
        <div class="notice notice-warning inline">
            <p><strong>Admin Note:</strong> Tracking is DISABLED for administrators by default. To test tracking yourself, append <code>?svt_test=1</code> to your website URL.</p>
        </div>
        <?php endif; ?>

        <div style="background:#fff; padding:20px; border-left:4px solid #2271b1; margin:20px 0; display:flex; gap:40px; box-shadow:0 1px 1px rgba(0,0,0,.1); align-items:center;">
            <div><h2>Total Traffic</h2><p style="font-size:24px; font-weight:bold; margin:0;"><?php echo $total_visits; ?></p></div>
            <div><h2>Companies</h2><p style="font-size:24px; font-weight:bold; margin:0; color:#2271b1;"><?php echo $companies; ?></p></div>
            <div><h2>Humans</h2><p style="font-size:24px; font-weight:bold; margin:0; color:#46b450;"><?php echo $humans_count; ?></p></div>
            
            <?php if($pending_count > 0): ?>
            <div style="margin-left:auto; text-align:right;">
                <p style="color:#e6a700; font-weight:bold; margin:0 0 5px 0;"><?php echo $pending_count; ?> Pending Lookups</p>
                <?php if($last_error): ?>
                    <p style="color:red; font-size:11px; margin:0 0 5px 0;">Last Error: <?php echo esc_html($last_error); ?></p>
                <?php endif; ?>
                <form method="post">
                    <input type="hidden" name="svt_run_queue" value="1">
                    <button type="submit" class="button button-primary">Force Process Recent 20</button>
                </form>
            </div>
            <?php else: ?>
            <div style="margin-left:auto;">
                <form method="post"><input type="hidden" name="svt_apply_filters" value="1"><button type="submit" class="button" title="Re-scan database against blacklist to tag ISPs">Apply Strict Filters</button></form>
            </div>
            <?php endif; ?>
        </div>

        <div style="margin-bottom:20px; display:flex; flex-wrap:wrap; justify-content:space-between; gap:10px; align-items:center;">
            <div class="btn-group">
                <a href="?page=simple-visitor-tracker" class="button <?php echo (!$hide_isp && !$show_humans) ? 'button-primary' : 'button-secondary'; ?>">All Traffic</a>
                <a href="?page=simple-visitor-tracker&hide_isp=1" class="button <?php echo $hide_isp ? 'button-primary' : 'button-secondary'; ?>">Companies Only</a>
                <a href="?page=simple-visitor-tracker&show_humans=1" class="button <?php echo $show_humans ? 'button-primary' : 'button-secondary'; ?>">Humans Only</a>
            </div>

            <div style="display:flex; gap:5px;">
                <form method="post" action="admin-post.php" style="display:inline-block;">
                    <input type="hidden" name="action" value="svt_export_csv">
                    <input type="hidden" name="scope" value="all">
                    <button class="button" title="Export Everything"><span class="dashicons dashicons-download"></span> All</button>
                </form>
                <form method="post" action="admin-post.php" style="display:inline-block;">
                    <input type="hidden" name="action" value="svt_export_csv">
                    <input type="hidden" name="scope" value="companies">
                    <button class="button button-primary" title="Export Companies Only (Strict)"><span class="dashicons dashicons-download"></span> Companies</button>
                </form>
                <form method="post" onsubmit="return confirm('Clear all data?');" style="display:inline-block;">
                    <input type="hidden" name="svt_clear_data" value="1">
                    <button class="button button-link-delete">Clear DB</button>
                </form>
            </div>
        </div>

        <form method="get">
            <input type="hidden" name="page" value="simple-visitor-tracker">
            <?php if($hide_isp): ?><input type="hidden" name="hide_isp" value="1"><?php endif; ?>
            <div class="tablenav top"><div class="tablenav-pages"><?php echo paginate_links($pagination_args); ?></div></div>
            <table class="wp-list-table widefat fixed striped">
                <thead><tr><th>Human</th><th style="width:120px;">Time</th><th>Location</th><th>Organization</th><th>Source</th><th style="width:200px;">Page Visited</th></tr></thead>
                <tbody>
                <?php if ($visits) : foreach ($visits as $v) : ?>
                    <tr>
                        <td style="text-align:center;">
                            <?php if($v->is_human): ?><span class="dashicons dashicons-admin-users" style="color:#46b450;"></span><?php else: ?><span class="dashicons dashicons-robot" style="color:#ddd;"></span><?php endif; ?>
                        </td>
                        <td><?php echo date('m-d H:i', strtotime($v->time)); ?></td>
                        <td><?php echo svt_get_flag_emoji($v->country_code); ?> <?php echo esc_html($v->country_name); ?></td>
                        <td>
                            <?php 
                            $org_display = esc_html($v->organization);
                            if ($v->lookup_status === 'pending') {
                                if (!empty($v->organization) && $v->organization !== 'Unknown') {
                                     echo '<strong>' . $org_display . '</strong> <span style="color:#e6a700; font-size:11px;">(Verifying...)</span>';
                                } else {
                                     echo '<span style="color:#e6a700;">Checking...</span>';
                                }
                            }
                            elseif (strpos($v->organization, '[ISP]') !== false) {
                                echo '<span style="color:#aaa;">' . $org_display . '</span>';
                            }
                            else {
                                echo '<strong style="color:#2271b1;">' . $org_display . '</strong>';
                            }
                            ?>
                        </td>
                        <td><?php echo esc_html($v->traffic_source); ?></td>
                        <td><a href="<?php echo esc_url($v->page_url); ?>" target="_blank" title="<?php echo esc_attr($v->page_url); ?>"><?php echo substr($v->page_url, 0, 50); ?><?php echo strlen($v->page_url) > 50 ? '...' : ''; ?></a></td>
                    </tr>
                <?php endforeach; endif; ?>
                </tbody>
            </table>
        </form>
    </div>
    <?php
}

function svt_display_settings() {
    // Basic settings handling
    if(isset($_POST['run_connection_test'])) {
        $url = get_option('svt_apps_script_url');
        if(empty($url)) {
            $test_result = "Error: URL is empty.";
        } else {
            // Force /exec
            if (strpos($url, '/exec') === false) {
                 $url = preg_replace('/\/edit.*$/', '/exec', $url);
            }
            // First try POST
            $response = wp_remote_post($url, [
                'body' => json_encode(['action' => 'test']),
                'headers' => ['Content-Type' => 'application/json'],
                'sslverify' => false,
                'timeout' => 10
            ]);
            
            // Check POST
            if(!is_wp_error($response)) {
                $json = json_decode(wp_remote_retrieve_body($response), true);
                if($json && $json['status'] === 'ok') {
                    $test_result = "SUCCESS! Connection established via POST.";
                } else {
                     // Try GET fallback
                     $get_url = $url . (strpos($url,'?')===false?'?':'&') . 'action=test';
                     $response = wp_remote_get($get_url, ['sslverify' => false]);
                     if(!is_wp_error($response)) {
                         $json = json_decode(wp_remote_retrieve_body($response), true);
                         if($json && $json['status'] === 'ok') {
                             $test_result = "SUCCESS! Connection established via GET (Fallback).";
                         } else {
                             // DIAGNOSTIC OUTPUT
                             $body = wp_remote_retrieve_body($response);
                             $html_preview = esc_html(substr(strip_tags($body), 0, 300));
                             $test_result = "FAILED: Invalid response. Go to your Script Deployment -> 'Who has access' must be 'Anyone'. Received: " . $html_preview;
                         }
                     } else {
                         $test_result = "GET Fallback Failed: " . $response->get_error_message();
                     }
                }
            } else {
                $test_result = "Connection Failed: " . $response->get_error_message();
            }
        }
    }
    ?>
    <div class="wrap">
        <h1>Tracker Settings <span style="font-size:12px; color:#666;">(v<?php echo SVT_VERSION; ?>)</span></h1>
        <?php if(isset($test_result)) echo '<div class="notice notice-info"><p>'.($test_result).'</p></div>'; ?>
        
        <form method="post" action="options.php">
            <?php settings_fields('svt_options_group'); do_settings_sections('svt_options_group'); ?>
            <h2 class="title">Database Connection</h2>
            <table class="form-table">
                <tr>
                    <th>Apps Script URL</th>
                    <td>
                        <input type="text" name="svt_apps_script_url" value="<?php echo esc_attr(get_option('svt_apps_script_url')); ?>" class="regular-text" style="width:100%;" />
                        <p class="description">Must end in <code>/exec</code></p>
                    </td>
                </tr>
            </table>
            <?php submit_button(); ?>
        </form>
        
        <form method="post">
            <input type="hidden" name="run_connection_test" value="1">
            <?php submit_button('Test Connection', 'secondary', 'submit', false); ?>
        </form>
        
        <hr>
        <h2 class="title">Daily Email Reports</h2>
        <form method="post" action="options.php">
            <?php settings_fields('svt_options_group'); do_settings_sections('svt_options_group'); ?>
             <table class="form-table">
                <tr><th scope="row">Enable Reports</th><td><label><input type="checkbox" name="svt_email_report_enable" value="1" <?php checked('1', get_option('svt_email_report_enable')); ?> /> Send me a daily email at 8:00 AM</label></td></tr>
                <tr><th scope="row">Recipients</th><td><input type="text" name="svt_email_recipients" value="<?php echo esc_attr(get_option('svt_email_recipients')); ?>" class="regular-text" /></td></tr>
                <tr><th scope="row">Sender Name</th><td><input type="text" name="svt_email_sender_name" value="<?php echo esc_attr(get_option('svt_email_sender_name', '01ST DIGITAL SOLUTIONS')); ?>" class="regular-text" /></td></tr>
                <tr><th scope="row">Sender Email</th><td><input type="email" name="svt_email_sender_address" value="<?php echo esc_attr(get_option('svt_email_sender_address', 'marketing@01st.info')); ?>" class="regular-text" /></td></tr>
            </table>
            <?php submit_button('Save Email Settings'); ?>
        </form>
    </div>
    <?php
}
`;

export const README_TXT = `=== Simple Visitor Tracker (Export Edition) ===
Contributors: Quest Generated
Version: 4.3.2
License: GPLv2 or later
Tracks visitors, filters bots, identifies traffic sources, allows data export, and sends daily reports.

== Features ==
* **Cloud Sync**: Automatically syncs your blacklist with a central Google Sheet.
* **Batch Processing**: Handles thousands of IP lookups efficiently.
* **Smart Bulk Importer**: Paste a list of companies/ISPs and let the plugin auto-categorize them.
* **Auto-Detect**: Detects generic ISPs (Server, Telecom, Cloud) and auto-adds them to the shared blacklist.
* **Detailed Reports**: Export "All Data", "Companies Only", or "Humans Only" to CSV.
* **Daily Email Reports**: Get a beautiful HTML email every morning.

== Setup ==
1. **Google Apps Script**: Deploy the included 'google-apps-script.js' as a Web App.
   - Ensure you create a Sheet named "Blacklist" in your spreadsheet.
2. **Settings**: Paste the Web App URL in WordPress Settings.
3. **Blacklist**: Use the "Bulk Import" feature with "Auto-Detect" mode to quickly secure your list.
4. **Queue Processing**: Use the "Force Process Recent 20" button to immediately resolve new visitors.
`;